<div class="text-lg font-semibold border-bottom-2 border-cyan-500 mb-2">Telefonbuch & Einzelverbindungsnachweis</div>
<ng-container *ngIf="phoneBookData.type === 'none'; else phoneBookEntry">
    kein Eintrag<br />
</ng-container>
<ng-template #phoneBookEntry>
    <ng-container *ngIf="phoneBookData.type === 'full'; else shortEntry">
        vollständiger Eintrag<br />
    </ng-container>
    <ng-template #shortEntry>
        verkürzter Eintrag<br />
    </ng-template>
    {{ phoneBookData.inverse ? 'Inverssuche erlauben' : 'Inverssuche nicht erlauben' }}
</ng-template>
<ng-container [ngSwitch]="phoneBookData.evn">
    <div *ngSwitchCase="'none'">kein Einzelverbindungsnachweis</div>
    <div *ngSwitchCase="'full'">vollständiger Einzelverbindungsnachweis</div>
    <div *ngSwitchCase="'short'">eingeschränkter Einzelverbindungsnachweis</div>
</ng-container>
